import React from 'react';

const Education = () => {
  return (
    <section id="education">
      <h1>Education</h1>
      <ul className="academic-list">
        <li>
          <h3>B.Tech – Computer Science</h3>
          <span className="org">Vellore Institute of Technology, AP</span>
          <div className="date">Aug 2022 – Jun 2026 | CGPA: 8.64</div>
        </li>
        <li>
          <h3>Class 12 (CBSE)</h3>
          <span className="org">Takshashila Public School</span>
          <div className="date">94.4%</div>
        </li>
        <li>
          <h3>Class 10 (CBSE)</h3>
          <span className="org">Takshashila Public School</span>
          <div className="date">97.8%</div>
        </li>
      </ul>
    </section>
  );
};

export default Education;
